import { apiWrapper } from "@/services/api";
import store from "@/store/index";

// 特急券IDを指定して引換券情報を取得する
export const getCouponWithTicketId = async (id) => {
  try {
    const resp = await apiWrapper(
      "GET",
      `/mfitt/coupons?limited_express_ticket_id=${id}`
    );

    store.commit("MFITT/setSelectedCoupon", resp.data[0]);
  } catch (err) {
    console.log('ERROR"" getCouponWithTicketId():', err);
    throw err;
  }
}